import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { Box, Flex, Grid, Heading, HStack, Text } from '@chakra-ui/react';
import { AdditionalFacilitiesFormFields } from 'src/@types';
import { additionalFacilitiesFormFields } from '../config';
import { AdditionalFacilitiesDisabilityWiaSection } from './additional-facilities-disability-wia-section';
import { AdditionalFacilitiesDisabilityWiaExcessSection } from './additional-facilities-disability-wia-excess-section';
import { AdditionalFacilitiesDisabilityWiaIncomeSection } from './additional-facilities-disability-wia-income-section';
import { FormElementDynamicInputTyped } from '../../../../shared/form-elements';
import { validationMessages } from '../../../../shared/validation/validation-messages';

export const AdditionalFacilitiesDisabilitySection = ({
  heading,
  register,
  values,
  errors
}: {
  heading: string;
  register: UseFormRegister<AdditionalFacilitiesFormFields>;
  errors: FieldErrors<AdditionalFacilitiesFormFields>;
  values: AdditionalFacilitiesFormFields;
}) => {
  return (
    <>
      <Heading size={`md`}>{heading}</Heading>
      <Grid
        templateColumns={{
          base: 'repeat(1, 1fr)'
        }}
        gap={4}>
        <Heading size={`md`}>De eerste twee ziektejaren:</Heading>
        <Text>
          Als werkgever bent u verplicht om uw werknemer door te betalen tijdens de eerste twee
          jaren van ziekte. Het uitkeringspercentage is afhankelijk van de CAO waaronder uw bedrijf
          valt, of van de afspraken die u met uw werknemer gemaakt heeft. U betaalt in het eerste
          jaar minimaal 70% van het loon door (en minimaal het minimumloon). In het tweede jaar
          betaalt u tevens minimaal 70% van het loon.
          <br />
          <br />
          Welke verdeling geldt binnen uw bedrijf voor de wettelijke loondoorbetalingtermijn in de
          eerste twee ziektejaren, als uw werknemer niet werkt?
        </Text>

        <HStack w={'100%'} align={'middle'} gap={4}>
          <Flex w={'40%'} height="auto" align="center" justify="center">
            <Text>Jaar 1</Text>
          </Flex>

          <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
            formFields={additionalFacilitiesFormFields}
            id={'percentageOfWagesDuringIllnessInTheFirstYearTheFirstHalf'}
            register={register}
            errors={errors}
            values={values}
            validation={{
              min: { value: 0, message: validationMessages.min(0) },
              max: { value: 100, message: validationMessages.max(100) },
              required: validationMessages.required
            }}
          />

          <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
            formFields={additionalFacilitiesFormFields}
            id={'percentageOfWagesDuringIllnessInTheFirstYearTheSecondHalf'}
            register={register}
            errors={errors}
            values={values}
            validation={{
              min: { value: 0, message: validationMessages.min(0) },
              max: { value: 100, message: validationMessages.max(100) }
            }}
          />
        </HStack>

        <HStack w={'100%'} align={'middle'} gap={4}>
          <Flex w={'40%'} height="auto" align="center" justify="center">
            <Text>Jaar 2</Text>
          </Flex>

          <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
            formFields={additionalFacilitiesFormFields}
            id={'percentageOfWagesDuringIllnessInTheSecondYearTheFirstHalf'}
            register={register}
            errors={errors}
            values={values}
            validation={{
              min: { value: 0, message: validationMessages.min(0) },
              max: { value: 100, message: validationMessages.max(100) },
              required: validationMessages.required
            }}
          />

          <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
            formFields={additionalFacilitiesFormFields}
            id={'percentageOfWagesDuringIllnessInTheSecondYearTheSecondHalf'}
            register={register}
            errors={errors}
            values={values}
            validation={{
              min: { value: 0, message: validationMessages.min(0) },
              max: { value: 100, message: validationMessages.max(100) }
            }}
          />
        </HStack>

        <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
          formFields={additionalFacilitiesFormFields}
          id={'wagesPercentageComposition'}
          register={register}
          errors={errors}
          values={values}
          options={{ required: true }}
        />

        <Text mb={4}>
          Na twee jaar ziekte treedt de wet WIA in werking. Uw werknemer ontvangt dan, afhankelijk
          van de mate van arbeidsongeschiktheid, een uitkering van het UWV. Ondanks deze uitkering
          is er vaak sprake van een grote inkomensterugval. Daarom sluiten veel werkgevers een
          aanvullende WIA-verzekering voor hun werknemers. Dit is in veel CAO-regelingen ook
          verplicht.
        </Text>

        <FormElementDynamicInputTyped<AdditionalFacilitiesFormFields>
          formFields={additionalFacilitiesFormFields}
          id={'haveYouTakenOutWiaInsuranceForYourEmployees'}
          register={register}
          errors={errors}
          values={values}
          options={{ required: true }}
        />

        {values.haveYouTakenOutWiaInsuranceForYourEmployees === 'true' && (
          <Box>
            <Text mb={4}>
              U heeft aangegeven dat u een collectieve WIA-verzekering heeft gesloten voor uw
              werknemers. Wilt u aangeven om welke dekking(en) het voor deze medewerker gaat?
            </Text>
            <AdditionalFacilitiesDisabilityWiaSection
              register={register}
              errors={errors}
              values={values}></AdditionalFacilitiesDisabilityWiaSection>

            <AdditionalFacilitiesDisabilityWiaExcessSection
              register={register}
              errors={errors}
              values={values}></AdditionalFacilitiesDisabilityWiaExcessSection>

            <AdditionalFacilitiesDisabilityWiaIncomeSection
              register={register}
              errors={errors}
              values={values}></AdditionalFacilitiesDisabilityWiaIncomeSection>
          </Box>
        )}
      </Grid>
    </>
  );
};
